<template>
  <div>
    <!-- <gSwiper></gSwiper> -->
    <div class="register">
      <registerForm ref="registerForm"></registerForm>
      <registerAddr ref="registerAddr" @changeExhibtion="changeEx"></registerAddr>

      <div class="f-tac submit-btn">
        <Button type="primary" size="large" long @click="handleSubmit" :loading="loading">Submit / 提交并完成报名</Button>
      </div>
    </div>
  </div>
</template>

<script>
import gSwiper from "@components2/gSwiper/gSwiper2mober.vue";
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerAddr from "./components/mobile-register-addr.vue";
export default {
  name: "register",
  components: {
    registerForm,
    registerAddr,
    gSwiper,
  },
  data () {
    return {
      loading: false,
      applyCompanyId: '',
      applyCompanyOrderId: '',
      exhibitionId: '',
    };
  },
  methods: {
    ...mapActions({
      addApplyCompany: "commonFill/addApplyCompany", //提交基本信息
      applyCompanyOrder: "commonFill/applyCompanyOrder", //提交基本信息
      addApplyOrder: "commonFill/addApplyOrder",
      finishApplyOperate: "commonFill/finishApplyOperate"
    }),
    async handleSubmit () {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);
      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerAddr.validHandle();
      this.loading = false;
      if (!res2.valid) return;
      console.log("registerForm", res);
      console.log("registerAddr", res2);
      let bool = await this.addApplyCompany(res.form);
      if (bool && bool.successed) {
        this.applyCompanyId = bool.info
        this.applyEx(res2.req)
      }
    },
    changeEx (e) {
      this.exhibitionId = e.id;
      console.log('changeEx', this.exhibitionId);
    },
    //直销展位报名
    async applyEx (opt) {
      let req = {
        "ApplyCompanyId": this.applyCompanyId,
        "ExhibitionId": this.exhibitionId,
        "IsAgent": '否',
        "AgentName": ""
      }
      let bool = await this.applyCompanyOrder(req);
      if (bool && bool.successed) {
        this.applyCompanyOrderId = bool.info.id
        this.applyOrder(opt)
      }
    },
    //创建展位订单
    async applyOrder (opt) {
      let req = {
        Id: this.applyCompanyOrderId,
        ApplyCompanyId: this.applyCompanyId,
        ExhibitionId: this.exhibitionId,
        IsAgent: "否",
        Remark: '',
        ApplyBoothOrderList: opt
      };
      opt.map(c => {
        c.ApplyCompanyOrderId = this.ApplyCompanyOrderId;
      });
      let info = await this.addApplyOrder(req);
      if (info && info.successed) {
        this.finished()
      }
    },
    async finished () {
      let req = {
        Id: this.applyCompanyOrderId,
        ApplyFileLink: "finished",
        IsMultipleEmail: false,
      }
      let bool = await this.finishApplyOperate(req);
      if (bool && bool.successed) {
        this.$Message.success("Submitted/提交成功");
        setTimeout(() => {
          this.$router.push({ path: "/basic/successEn" });
        }, 1500)
      }
      else {
        this.$Message.fail('Failed/提交失败')
      }
    },
    IsPC () {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    },
  },
  created () {
    if (this.IsPC()) {
      this.$router.push(`/fillEn/join/basicEn`);
    }
    document.title = "Higher Education Expo China ";
  },
};
</script>

<style lang="scss" scoped>
.register {
  margin: 0 auto;
  background: #f7f7f7;

  .top {
    padding: 15px;
  }

  .title {
    font-size: 15px;
    color: #00a1e9;
    font-weight: bold;
    line-height: 32px;
  }
}

.submit-btn {
  text-align: center;
  padding: 20px 15px 0;

  button {
    background-color: #00a1e9;
    font-size: 15px;
    border-color: #00a1e9;
    margin-bottom: 30px;
    height: 40px;
    color: #fff;
  }
}

.tip-info {
  margin: 25px auto 15px auto;
  padding: 0 15px;
  white-space: nowrap;
  color: #666;

  p {
    font-size: 13px;
    margin-bottom: 4px;
    white-space: normal;
  }
}

.register-box {
  background: #fff;
  padding-bottom: 30px;
  margin-bottom: 30px;

  .tip {
    font-size: 15px;
    line-height: 24px;
    color: #f00;
    padding-left: 15px;
    font-weight: 500;
  }
}

.top-title {
  line-height: 50px;
  align-items: center;
  padding-left: 15px;
  font-size: 13px;
  color: #333;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e6e6e6;

  .line {
    content: "";
    width: 3px;
    height: 15px;
    background-color: #00a1e9;
    margin-right: 7px;
  }

  span {
    font-size: 15px;
    color: #f00;
  }

  &-left {
    flex: 1;
    text-align: right;
    display: flex;
    justify-content: flex-end;
    padding-right: 15px;
  }
}
</style>
